import React from 'react';
import PropTypes from 'prop-types';
import TermDefinition from '../TermDefinition';
import styles from './styles.module.styl';

const LetterSection = ({ letter, terms }) => (
  <section>
    <h2 id={letter} className={styles.letterHeader}>{letter}</h2>
    <ul className={styles.terms}>
      {terms.map(term => <TermDefinition {...term} />)}
    </ul>
  </section>
);

const termValidation = {
  term: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired
};

LetterSection.propTypes = {
  letter: PropTypes.string.isRequired,
  terms: PropTypes.arrayOf(PropTypes.shape(termValidation))
};

export default LetterSection;
